/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Promotion } from '../../Promotion.model';
import rewardImgPlaceholder from '../../../../_assets/bhvr-footer.png';

interface Props {
  promotion: Promotion
}

export function PromotionHeader({ promotion }: Props): JSX.Element {
  const { t } = useTranslation();
  const { rewards } = promotion.promotionData;

  return (
    <div className='promotion-header'>
      {rewards.map((reward) => (
        <img
          key={reward.displayName}
          className='promotion-header-reward-img'
          src={process.env.NODE_ENV === 'development' ? rewardImgPlaceholder : reward.pictureURL}
          alt={t(`promotions:${reward.displayName}`)}
        />
      ))}
    </div>
  );
}
